<template>
    <div>
		<div class="box-header with-border"
			v-if="title || $slots['header-actions']">
			<div class="row">
				<div v-if="!!title" :class="{
					'col-xs-12': true, 
					'col-md-5': $slots['header-actions'],
				}">
					<h3 class="box-title">{{ title }}</h3>
				</div>
				<div v-if="$slots['header-actions']" :class="{
					'col-xs-12': true, 
					'col-md-7': title,
					'text-right': true,
				}">
					<div class="page-actions reverse">
						<slot name="header-actions"></slot>
					</div>
				</div>
			</div>
		</div>

		<div class="box-body">
			<slot></slot>
		</div>

		<div v-if="!!$slots.footer" class="box-footer">
			<slot name="footer"></slot>
		</div>
    </div>
</template>

<script>
import { getConfig } from '../helpers'
export default {
	created() {
		this.updateBrowserTabTitle()
	},
	methods: {
		updateBrowserTabTitle() {
			const pageTitle = [
				this.title,
				getConfig('company-name')
			]

			document.title = pageTitle.filter(word => Boolean(word)).join(' | ')
		}
	},
	props: {
		title: {
			type: String,
			required: false,
			default: null,
		},
	},
	watch: {
		title: {
			handler() {
				this.updateBrowserTabTitle()
			},
			immediate: true,
		},
	},
}
</script>
